import * as React from 'react'
import styled, { hexToRgb, hexToRgba } from '../../../theme/styled'

import CloseButton from '../../Shared/CloseButton'
import { withRouter } from 'react-router'

const FeatureContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${({ theme }) => hexToRgb(theme.colors.brand)};
  background: ${({ theme }) => hexToRgba(theme.colors.brand, '0.95')};
  z-index: 1000;
  padding: 20px;
  overflow: auto;

  .close-feature2 {
    position: absolute;
    top: 30px;
    right: 45px;
    color: ${({ theme }) => theme.colors.invert};
  }

  .feature-content2 {
    margin: 40px auto 40px;
    max-width: 1400px;
    /* Stop margin collapse */
    padding-top: 1px;
  }

  .feature-title2 {
    color: ${({ theme }) => theme.colors.invert};
    font-weight: bold;
    font-size: ${({ theme }) => theme.fonts.titleSize};
    margin-bottom: 25px;
  }
`

const CommonGreen = props => (
  <FeatureContainer>
    <CloseButton
      white={true}
      className="close-feature2"
      onClick={() => props.history.goBack()}
    >
      x
    </CloseButton>
    <div className="feature-content2">{props.children}</div>
  </FeatureContainer>
)

export default withRouter(CommonGreen)



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/CommonGreen.tsx